import {
  UPDATE_SUPPLIER,
  RESET_SUPPLIER
} from "./actionTypes"

export const update_supplier = supplier => {
  return {
    type: UPDATE_SUPPLIER,
    payload: supplier,
  }
}

export const reset_supplier = () => {
  return {
    type: RESET_SUPPLIER,
  }
}
